import { makeStyles } from '@futrli/ui-components';

export const textCardStyles = makeStyles({
  root: {
    'padding': 8,
    'font-size': 11,
    'color': '#000',
    '& .ql-container': {
      'font-family': 'SageUI'
    },
    '& .ql-container.ql-snow': {
      'border': 'none',
      '& .ql-tooltip': {
        position: 'initial',
        transform: 'unset',
        maxWidth: '400px'
      }
    },
    '& .ql-editor': {
      padding: 0
    },
    '& .ql-font-Arial': {
      'font-family': 'Arial'
    },
    '& .ql-font-SageUI': {
      'font-family': 'SageUI'
    },
    '& .ql-font-times-new-roman': {
      'font-family': '"Times New Roman"'
    }
  }
});
